(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const countrySelectors = document.querySelectorAll('.popout-list__option');

    countrySelectors.forEach(selector => {
      selector.addEventListener('click', function () {
        const countryCode = this.getAttribute('data-country-code');
        const countryLanguage = this.getAttribute('data-country-language');
        
        // Store the selected country in localStorage
        localStorage.setItem('SELECTED_COUNTRY', countryCode);
        localStorage.setItem('SELECTED_LANGUAGE', countryLanguage.toLowerCase().slice(0, 2));
        
        updateLocalization({ country: countryCode, language: countryLanguage.toLowerCase().slice(0, 2) });
      });
    });
  });

  function updateLocalization({ country, language }) {
    if (country === 'UK') {
      country = 'GB';
    }

    if (country === 'EU') {
      country = 'DE';
    }

    const formId = crypto.randomUUID();
    const formHtml = `
    <form id="${formId}" action="/localization" method="POST" hidden>
      <input name="_method" value="PUT">
      <input name="country_code" value="${country}">
      <input name="language_code" value="${language}">
    </form>
  `;
    document.body.insertAdjacentHTML("beforeend", formHtml);
    document.getElementById(formId).submit();
  }

  class CountrySelector extends HTMLElement {
    constructor() {
      super();
      this.LOCAL_STORAGE_KEY = 'COUNTRY_CHECKED';
      this.SELECTED_COUNTRY_KEY = 'SELECTED_COUNTRY';
      this.SELECTED_LANGUAGE_KEY = 'SELECTED_LANGUAGE';
      this.currentCountry = this.getAttribute('data-current-country');
      this.currentLanguage = this.getAttribute('data-current-language');
      if (this.currentCountry == "GB") {
        this.currentCountry = "UK";
      }

      if (this.currentCountry == "DE") {
        this.currentCountry = "EU";
      }

      // Logging
      // console.log('Current country:', this.currentCountry);
      // console.log('Current language:', this.currentLanguage);

      // Check if user has a stored country preference and redirect if needed
      this.checkStoredCountryPreference();

      if (this.hasCountryBeenChecked()) {
        return;
      }

      const _this = this;

      const closeButton = this.querySelector('[data-popup-close]');
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          _this.removeCountrySelector();
          localStorage.setItem(_this.LOCAL_STORAGE_KEY, 'true');
        });
      } else {
        console.log('Close button not found');
      }

      this.addEventListener('click', (event) => {
        if (!event.target.closest('.country-selector__content')) {
          _this.removeCountrySelector();
          localStorage.setItem(_this.LOCAL_STORAGE_KEY, 'true');
        }
      });

      try {
        console.log('Fetching geolocation data');
        fetch(
          `https://rebuyengine.com/api/v1/customers/geolocation?key=06c0934b6d04add29935a8b78521d404b0df5cf5`
        )
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            const geo = data;

            if (_this.shouldShowPopup(geo.data)) {
              setTimeout(() => {
                _this.showCountrySelector();
              }, 1000);
            } else {
              localStorage.setItem(_this.LOCAL_STORAGE_KEY, 'true');
            }
          });
      } catch (err) {
        console.error('Error in Country Locator', err);
      }

      const links = [...this.querySelectorAll(".popout-list__option")];
      this.countryCodes = links.map(link => link.dataset.countryCode);

      links.forEach((link) => {
        link.addEventListener("click", () => {
          localStorage.setItem(_this.LOCAL_STORAGE_KEY, 'true');
          _this.removeCountrySelector();
        });
      });
    }

    checkStoredCountryPreference() {
      const isDesignMode = document.documentElement.classList.contains('is-design-mode');
      if (isDesignMode) {
        console.log('Design mode detected. Not checking for stored country preference.');
        return;
      }

      const overrideCountryQuery = new URLSearchParams(window.location.search).get('country');

      if(overrideCountryQuery) {
        localStorage.removeItem(this.LOCAL_STORAGE_KEY);
        localStorage.removeItem(this.SELECTED_COUNTRY_KEY);
        localStorage.removeItem(this.SELECTED_LANGUAGE_KEY);
        return;
      }

      const storedCountry = localStorage.getItem(this.SELECTED_COUNTRY_KEY);
      const storedLanguage = localStorage.getItem(this.SELECTED_LANGUAGE_KEY);

      // Logging
      // console.log('Stored country:', storedCountry);
      // console.log('Stored language:', storedLanguage);
      
      if (storedCountry && storedCountry !== this.currentCountry) {
        // Logging
        // console.log('Stored country preference detected:', storedCountry, 'current:', this.currentCountry);
        // console.log('Redirecting to stored country preference');
        
        // Use the existing updateLocalization function to redirect
        updateLocalization({ 
          country: storedCountry, 
          language: storedLanguage || 'en' 
        });
      }
    }

    shouldShowPopup(geo) {
      const detectedCountryCode = geo.country_code;
      const detectedContinentCode = geo.continent_code;

      // Logging
      // console.log('Checking if should show popup for:', detectedCountryCode);

      const countryCodes = this.countryCodes;

      if (detectedCountryCode !== this.currentCountry) {
        if (!countryCodes.includes(this.currentCountry) && detectedContinentCode == "EU") {
          console.log('Should not show - EU country detected');
          return false;
        }

        console.log('Should show - different country detected');
        return true;
      }

      console.log('Should not show popup');
      return false;
    }

    showCountrySelector() {
      if (this) {
        this.classList.add("show");
      }
    }

    removeCountrySelector() {
      console.log('Removing country selector');
      if (this) {
        this.classList.remove("show");
      }
    }

    hasCountryBeenChecked() {
      const checked = typeof window !== 'undefined'
        ? localStorage.getItem(this.LOCAL_STORAGE_KEY)
        : true;

      return checked;
    }
  }

  customElements.define("country-selector", CountrySelector)
})();